import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useState } from 'react';
import omit from 'lodash/omit';
import { FormControl } from '@cancercentrum/rcc-bootstrap';
import { useRegvarValidator } from '../hooks/useRegvarValidator';
const RegvarString = (props)=>{
    const { inputRef, readOnly, textarea, readOnlyComponentClass, type = 'text', ...rest } = props;
    const [value, setValue] = useState(props.value ?? null);
    const val = useRegvarValidator();
    useEffect(()=>{
        setValue(props.value ?? null);
    }, [
        props.value
    ]);
    const onChange = (e)=>{
        setValue(e.target.value);
    };
    const onBlur = (e)=>{
        const parse = props.valueParser || ((x)=>x);
        const newVal = parse(e.target.value);
        props.onChange(newVal);
        setValue(newVal);
    };
    if (readOnly) {
        const El = readOnlyComponentClass || 'div';
        if (typeof El === 'string') {
            return /*#__PURE__*/ _jsx(El, {
                className: "form-control-plaintext",
                children: value
            });
        }
        return /*#__PURE__*/ _jsx(El, {
            ...props,
            value: value
        });
    }
    const propsToPass = omit(rest, [
        'regvarMetadata',
        ...val.getValidationPropNames([
            'required',
            'pattern'
        ])
    ], 'valueParser');
    const Input = textarea ? 'textarea' : 'input';
    return /*#__PURE__*/ _jsx(FormControl, {
        ...propsToPass,
        componentClass: Input,
        value: value || '',
        onChange: onChange,
        onBlur: onBlur,
        ref: inputRef,
        type: type
    });
};
export default /*#__PURE__*/ memo(RegvarString);
